import Dexie from "dexie";

interface VideoChunk {
  id?: number;
  order: number;
  from: number;
  to: number;
  blob: Blob;
}

interface VideoMeta {
  id?: number;
  url: string;
  chunkCount: number;
  chunkSize: number;
}

export class VideoChunkDatabase extends Dexie {
  videoChunks?: Dexie.Table<VideoChunk, number>;
  meta?: Dexie.Table<VideoMeta, number>;

  constructor(dbName: string, version = 1) {
    super(dbName);
    this.version(version).stores({
      videoChunks: "++id,from, end, order, blob",
      meta: "++id,url,chunkCount,chunkSize"
    });
  }
}
